import { type ActivationErrorTypes, type BTLoginTypes } from "types/enum";

export interface ICredentialsFormValues {
    username: string | undefined;
    password: string | undefined;
}

export interface IUserActivationRequest {
    username: string;
    password: string;
    builderID?: string;
    shareToken: string;
}

export class ActivationResponse {
    constructor(data: any) {
        this.globalUserId = data.globalUserId;
        this.loginType = data.loginType;
        this.cellNumber = data.cellNumber;
        this.isMfaEnabled = data.isMfaEnabled;
        this.usernameAlreadyExists = data.usernameAlreadyExists;
        this.invalidCredentials = data.invalidCredentials;
        this.previousActivation = data.previousActivation
            ? new PreviousActivation(data.previousActivation)
            : undefined;
        this.credentialId = data.credentialId;
        this.errorType = data.errorType;
        this.logoSrc = data.logoSrc;
        this.sessionLoginType = data.sessionLoginType;
        this.builderName = data.builderName;
    }

    globalUserId: number;
    loginType: BTLoginTypes;
    cellNumber: string;
    isMfaEnabled: boolean;
    usernameAlreadyExists: boolean;
    invalidCredentials: boolean;
    previousActivation: PreviousActivation | undefined;
    credentialId: number;
    errorType: ActivationErrorTypes;
    logoSrc: string;
    sessionLoginType: BTLoginTypes;
    builderName: string;
}

export class PreviousActivation {
    constructor(data: any) {
        this.globalUserId = data.globalUserId;
        this.isActive = data.isActive;
        this.loginType = data.loginType;
        this.nameOfAccount = data.nameOfAccount;
    }

    globalUserId: number;
    isActive: boolean;
    loginType: BTLoginTypes;
    nameOfAccount: string;
}
